import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SmallCategory } from 'store/budgetStore';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faTimes } from '@fortawesome/free-solid-svg-icons';
import EditItemModal from 'modules/budget/components/budget-modals/edit-item-modal';
import DeleteItemModal from 'modules/budget/components/budget-modals/delete-item-modal';

class SmallCategoryButtons extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showEditModal: false,
            showDeleteModal: false,
        };

        this.showEditModal = this.showEditModal.bind(this);
        this.hideEditModal = this.hideEditModal.bind(this);
        this.showDeleteModal = this.showDeleteModal.bind(this);
        this.hideDeleteModal = this.hideDeleteModal.bind(this);
    }

    showEditModal() {
        this.setState({showEditModal: true});
    }

    hideEditModal() {
        this.setState({showEditModal: false});
    }

    showDeleteModal() {
        this.setState({showDeleteModal: true});
    }

    hideDeleteModal() {
        this.setState({showDeleteModal: false});
    }

    render() {
        const { category } = this.props;
        const { budgeted } = category;
        const isUnbudgeted = budgeted === 0;

        const editItemModal = this.state.showEditModal ? (
            <EditItemModal
                smallCategoryRef={category}
                onSuccess={this.hideEditModal}
                onDismiss={this.hideEditModal} />
        ) : null;

        const deleteItemModal = this.state.showDeleteModal ? (
            <DeleteItemModal
                smallCategoryRef={this.props.category}
                onSuccess={this.hideDeleteModal}
                onDismiss={this.hideDeleteModal} />
        ) : null;

        return (
            <div className="btn-group">
                <button onClick={this.showEditModal} className="btn btn-xs btn-default pen-btn">
                    <FontAwesomeIcon icon={faPen} className="edit-pen" fixedWidth={true} />
                </button>
                {!isUnbudgeted && (
                    <button onClick={this.showDeleteModal} className="btn btn-xs btn-default times-btn">
                        <FontAwesomeIcon icon={faTimes} className="remove-times" fixedWidth={true} />
                    </button>
                )}
                {editItemModal}
                {deleteItemModal}
            </div>
        );
    }
}

SmallCategoryButtons.propTypes = {
    /** Instance of SmallCategory from store */
    category: PropTypes.instanceOf(SmallCategory).isRequired,
};

export default SmallCategoryButtons;



// WEBPACK FOOTER //
// ./src/modules/budget/components/budget-table/small-category-buttons.js